import { DEFAULT_SPLASH_IMAGE } from "%/constants/publication-constants";

export const STORY_VARIANT_TYPE_X = "x_post";
export const STORY_VARIANT_TYPE_LINKEDIN = "linkedin_post";
export const STORY_VARIANT_TYPE_INSTAGRAM = "instagram_post";
export const STORY_VARIANT_TYPE_INSTAGRAM_STORY = "instagram_story_post";
export const STORY_VARIANT_TYPE_FACEBOOK = "facebook_post";
export const STORY_VARIANT_TYPE_PINTEREST = "pinterest_post";
export const STORY_VARIANT_TYPE_YOUTUBE = "youtube_post";
export const STORY_VARIANT_TYPE_TIKTOK = "tiktok_post";
export const STORY_VARIANT_TYPE_BLUESKY = "bluesky_post";
export const STORY_VARIANT_TYPE_STORY = "publication_post";
export const STORY_VARIANT_TYPE_SYNDICATION = "syndication_post";
export const STORY_VARIANT_TYPE_NEWSLETTER = "email";
export const STORY_VARIANT_TYPE_SEASON = "season";
export const STORY_VARIANT_TYPE_EPISODE = "episode";
export const STORY_VARIANT_TYPE_LESSON = "lesson";
export const STORY_VARIANT_TYPE_COURSE = "course";
export const STORY_VARIANT_TYPE_CONCEPT = "concept";
export const STORY_VARIANT_TYPE_OUTLINE = "outline";
export const STORY_VARIANT_TYPE_VIDEO = "video";

export const STORY_VARIANT_TYPES = [
  {
    label: "X",
    value: STORY_VARIANT_TYPE_X,
    description: "Variant for X",
    splash: DEFAULT_SPLASH_IMAGE,
  },
  {
    label: "LinkedIn",
    value: STORY_VARIANT_TYPE_LINKEDIN,
    description: "Variant for LinkedIn",
    splash: DEFAULT_SPLASH_IMAGE,
  },
  {
    label: "Instagram",
    value: STORY_VARIANT_TYPE_INSTAGRAM,
    description: "Variant for Instagram",
    splash: DEFAULT_SPLASH_IMAGE,
  },
  {
    label: "Instagram Story",
    value: STORY_VARIANT_TYPE_INSTAGRAM_STORY,
    description: "Variant for an Instagram Story (one image or one video, no caption)",
    splash: DEFAULT_SPLASH_IMAGE,
  },
  {
    label: "Facebook",
    value: STORY_VARIANT_TYPE_FACEBOOK,
    description: "Variant for Facebook",
    splash: DEFAULT_SPLASH_IMAGE,
  },
  {
    label: "Pinterest",
    value: STORY_VARIANT_TYPE_PINTEREST,
    description: "Variant for Pinterest",
    splash: DEFAULT_SPLASH_IMAGE,
  },
  {
    label: "YouTube",
    value: STORY_VARIANT_TYPE_YOUTUBE,
    description: "Variant for YouTube",
    splash: DEFAULT_SPLASH_IMAGE,
  },
  {
    label: "TikTok",
    value: STORY_VARIANT_TYPE_TIKTOK,
    description: "Variant for TikTok",
    splash: DEFAULT_SPLASH_IMAGE,
  },
  {
    label: "BlueSky",
    value: STORY_VARIANT_TYPE_BLUESKY,
    description: "Variant for BlueSky",
    splash: DEFAULT_SPLASH_IMAGE,
  },
  {
    label: "Story",
    value: STORY_VARIANT_TYPE_STORY,
    description: "Variant for Story",
    splash: DEFAULT_SPLASH_IMAGE,
  },
  {
    label: "Syndication Market",
    value: STORY_VARIANT_TYPE_SYNDICATION,
    description: "Variant for Syndication Market",
    splash: DEFAULT_SPLASH_IMAGE,
  },
  {
    label: "Publication Newsletter Email",
    value: STORY_VARIANT_TYPE_NEWSLETTER,
    description: "Variant to send to your publication's newsletter mailing list",
    splash: DEFAULT_SPLASH_IMAGE,
  },
  {
    label: "Publication Season",
    value: STORY_VARIANT_TYPE_SEASON,
    description: "Variant for season",
    splash: DEFAULT_SPLASH_IMAGE,
  },
  {
    label: "Publication Episode",
    value: STORY_VARIANT_TYPE_EPISODE,
    description: "Variant for episode",
    splash: DEFAULT_SPLASH_IMAGE,
  },
  {
    label: "Publication Lesson",
    value: STORY_VARIANT_TYPE_LESSON,
    description: "Variant for lesson",
    splash: DEFAULT_SPLASH_IMAGE,
  },
  {
    label: "Publication Course",
    value: STORY_VARIANT_TYPE_COURSE,
    description: "Variant for course",
    splash: DEFAULT_SPLASH_IMAGE,
  },
  {
    label: "Concept",
    value: STORY_VARIANT_TYPE_CONCEPT,
    description: "Variant for Concept",
    splash: DEFAULT_SPLASH_IMAGE,
  },
  {
    label: "Outline",
    value: STORY_VARIANT_TYPE_OUTLINE,
    description: "Variant for Outline",
    splash: DEFAULT_SPLASH_IMAGE,
  },
  {
    label: "Video",
    value: STORY_VARIANT_TYPE_VIDEO,
    description: "Publication story whose primary content is a video",
    splash: DEFAULT_SPLASH_IMAGE,
  },
];
